<template>
  <div>
    <div
        v-if="object.bookingPrice && parseInt(object.bookingDays) >= 61"
        class="list-object-price"
    >
      <span style="color: #219AC8;">
        {{ Math.round(object.bookingPrice / parseInt(object.bookingDays) * 30) }}€
      </span>
      / {{ $i18n.t('month').toLowerCase() }}
    </div>
    <div
      v-else-if="object.bookingPrice"
      class="list-object-price"
    >
      <span style="color: #219AC8;">
        {{ object.bookingPrice }}€
      </span>
      / {{ object.bookingDays }} {{ parseInt(object.bookingDays) === 1 ? $i18n.t('öö').toLowerCase() : $i18n.t('ööd') }}
    </div>
    <div
      v-if="object.bookingDays < object.minDays"
      class="list-price-min-days-note"
    >
      {{ $i18n.t('min') }} {{ object.minDays }} {{ $i18n.t('ööd') }}
    </div>
    <div
      v-if="!object.bookingPrice"
      class="list-object-price"
    >
      <span style="color: #219AC8;">
        {{ $i18n.t('alates') }} {{ object.dayPrice || (Math.ceil(object.price / 7)) }}€
      </span>
      / {{ $i18n.t('öö').toLowerCase() }}
    </div>
  </div>
</template>

<script>
import { createHelpers } from 'vuex-map-fields'
import state from './../state.js'
const { mapFields } = createHelpers({
  getterType: 'getField',
  mutationType: 'updateField'
})

export default {
  name: 'ObjectPrice',

  computed: {
    ...mapFields(Object.keys(state))
  },

  props: {
    object: {
      type: Object,
      default: () => {
        return {}
      }
    },
  }
}
</script>

<style>
.list-object-price {
  color: grey;
  float: left;
  font-weight: bold;
  font-size: 1.2em;
  width: 100%;
}
.list-price-min-days-note {
  float: left;
  width: 100%;
  /* color: #219AC8; */
  font-weight: bold;
  padding-left: 10px;
  /* line-height: 27px; */
  font-size: 14px;
}
</style>
